// extracted by mini-css-extract-plugin
export default {"container":"GenericAlert_container__37ih-"};